// Models
import Model from './Model'

class Card extends Model {
  get isStatusNotActive () {
    return this.status === CARD_STATUSES.NOT_ACTIVE
  }

  get isStatusActive () {
    return this.status === CARD_STATUSES.ACTIVE
  }

  get isBlockedByHolder () {
    return this.status === CARD_STATUSES.BLOCKED_BY_HOLDER
  }

  get isBlockedByPartner () {
    return this.status === CARD_STATUSES.BLOCKED_BY_PARTNER
  }

  get isBlockedTemporary () {
    return this.isBlockedByHolder || this.isBlockedByPartner
  }

  get isBlockedPermanently () {
    return this.status === CARD_STATUSES.BLOCKED_PERMANENTLY
  }

  get isBlocked () {
    return this.isBlockedTemporary || this.isBlockedPermanently
  }

  get expiryDate () {
    return new Date(this.expiry)
  }

  static get statusOptions () {
    return [
      { name: 'Not active', value: CARD_STATUSES.NOT_ACTIVE },
      { name: 'Active', value: CARD_STATUSES.ACTIVE },
      { name: 'Blocked by holder', value: CARD_STATUSES.BLOCKED_BY_HOLDER },
      { name: 'Blocked by partner', value: CARD_STATUSES.BLOCKED_BY_PARTNER },
      { name: 'Blocked permanently', value: CARD_STATUSES.BLOCKED_PERMANENTLY }
    ]
  }

  get schema () {
    return [
      'id',
      'status',
      'maskedPan',
      'expiry',
      'cardName',
      'createdAt',
      'updatedAt',
      'reserved'
    ]
  }
}

export const CARD_STATUSES = {
  NOT_ACTIVE: 'NOT_ACTIVE',
  ACTIVE: 'ACTIVE',
  BLOCKED_BY_HOLDER: 'BLOCKED_BY_HOLDER',
  BLOCKED_BY_PARTNER: 'BLOCKED_BY_PARTNER',
  BLOCKED_PERMANENTLY: 'BLOCKED_PERMANENTLY'
}

export const CARD_BLOCK_STATUSES = {
  BY_HOLDER: 'BY_HOLDER',
  BY_PARTNER: 'BY_PARTNER',
  PERMANENTLY: 'PERMANENTLY'
}

export const CARD_FEE_TYPES = {
  DELIVERY: 'CARD_DELIVERY',
  ISSUING: 'CARD_ISSUING',
  PIN_AS_SMS: 'CARD_PIN_AS_SMS'
}

export const CARD_CURRENCIES = ['EUR', 'USD', 'GBP', 'RUB']

export default Card
